<template>
  <div class="box">
    <div class="columns" style="align-items: flex-end">
      <div class="column col-6">
        <ContractBox :data="data" />
        <div class="padding-top20 text-bold">
          {{ data.correction ? 'Popravek' : 'Mesečno poročilo za obdobje' }} <span v-if="!data.correction">{{ formatDate(data.date, 'MMMM YYYY') }}</span>
        </div>
      </div>
      <div class="column col-6 text-right small">
        <div>{{ data.user }}</div>
        <div>{{ formatDate(data.dateUpdate, 'DD.MM.YYYY HH:mm') }}</div>
      </div>
    </div>
    <hr />
    <TransactionList v-if="data.transactionList && data.transactionList.length > 0" :disabled="true" :cancellation="true" v-model="data.transactionList" />
    <div v-else class="text-bold">Ni bilo plačil.</div>
  </div>
  <div class="text-right padding-top20">
    <button class="button trans" @click="$router.push({ name: admin ? 'adminReportList' : 'reportList' })">Nazaj</button>
  </div>
</template>

<script lang="ts">
import TransactionList from '@/components/TransactionList.vue'
import ContractBox from './ContractBox.vue'
import { useApi } from '@/lib/api'
import { formatDate } from '@/lib/filters'
import { computed, defineComponent, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useAppViewedList } from '@/lib/common'

export default defineComponent({
  components: { TransactionList, ContractBox },
  setup() {
    const { setRecord } = useAppViewedList()
    const _api = useApi()
    const _route = useRoute()
    const data = ref({ contract: { client: {}, dateFrom: null, dateTo: null, transactionList: [] } })

    const getData = async () => {
      const res = await _api.get<any>('report?id=' + _route.params.id)
      if (res.status === 200) {
        const r = admin.value ? 'adminReportList' : 'reportList'
        setRecord(r + res.data.id)
        data.value = res.data
      }
    }

    const admin = computed(() => _route.fullPath.indexOf('/administracija') === 0)

    getData()

    return { data, formatDate, admin }
  }
})
</script>
